(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitmarket-feedaty"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const endpoint = 'https://widget.feedaty.com/v3.0.0/template/2021,carousel,carosello-1,6a61d1399ee64/10216708/all,all/null,null,null.json';
    let request;
    const text = (node, selector) => node.querySelector(selector)?.textContent.trim().replace(/\s+/g, ' ') || '';
    function getData() {
      if (!request) request = fetch(endpoint).then(response => { if (!response.ok) throw new Error('Feedaty unavailable'); return response.json(); }).then(payload => {
        const html = payload['6a61d1399ee64']?.html;
        if (!html) throw new Error('Feedaty response unavailable');
        const source = new DOMParser().parseFromString(html, 'text/html');
        const summary = source.querySelector('.fdt_info')?.getAttribute('aria-label') || '';
        const rating = Number(summary.match(/Valutazione media ([\d.]+) stelle/)?.[1]);
        const count = text(source, '.ratings-count .count');
        if (!(rating > 0 && rating <= 5) || !count) throw new Error('Feedaty rating unavailable');
        const reviews = Array.from(source.querySelectorAll('.fdt_carousel__item')).map(item => ({
          text: text(item, '.rev_text'), date: text(item, '.rev_date'),
          rating: Number(item.querySelector('.fdt_rev_stars img')?.getAttribute('alt')?.match(/[\d.]+/)?.[0]),
          verified: Boolean(item.querySelector('.checked_reviewer'))
        })).filter(review => review.text && review.rating > 0 && review.rating <= 5);
        return { rating, count, reviews };
      }).catch(error => { request = undefined; throw error; });
      return request;
    }
    function element(tag, className, value) { const node = document.createElement(tag); node.className = className; if (value) node.textContent = value; return node; }
    function stars(rating, label) { const node = element('span', 'fm-feedaty__stars', '★★★★★'); node.style.setProperty('--fm-fill', `${rating * 20}%`); node.setAttribute('role', 'img'); node.setAttribute('aria-label', `${rating.toLocaleString('it-IT')} ${label}`); return node; }
    function initialise(scope = document) {
      const sections = Array.from(scope.querySelectorAll('[data-fm-feedaty]')).filter(root => !root.dataset.initialised);
      if (!sections.length) return;
      sections.forEach(root => { root.dataset.initialised = 'true'; });
      getData().then(data => {
        sections.filter(root => root.isConnected).forEach(root => {
          const labels = root.dataset.labels.split('|');
          const summary = root.querySelector('[data-fm-summary]');
          summary.replaceChildren(stars(data.rating, labels[2]), element('strong', 'fm-feedaty__rating', `${data.rating.toLocaleString('it-IT')} / 5`), element('span', 'fm-feedaty__count', `${data.count} ${labels[0]}`));
          summary.hidden = false;
          document.querySelectorAll('[data-fm-review-proof]').forEach(proof => { proof.textContent = `${data.count} ${labels[0]}`; });
          const track = root.querySelector('[data-fm-track]');
          if (!track || !data.reviews.length) return;
          track.replaceChildren(...data.reviews.map(review => {
            const article = element('article', 'fm-feedaty__review');
            const top = element('div', 'fm-feedaty__review-top');
            top.append(stars(review.rating, labels[2]), element('span', 'fm-feedaty__date', review.date));
            article.append(top, element('blockquote', '', review.text));
            if (review.verified) article.append(element('span', 'fm-feedaty__verified', `✓ ${labels[1]}`));
            if (review.text.length > 140) { const link = element('a', 'fm-feedaty__link fm-feedaty__review-link', labels[3]); link.href = 'https://www.feedaty.com/it/recensioni/fitmarket'; link.target = '_blank'; link.rel = 'noopener'; article.append(link); }
            return article;
          }));
          track.hidden = false;
          root.querySelector('[data-fm-selection]').hidden = false;
          const controls = root.querySelector('[data-fm-controls]');
          controls.hidden = false;
          const prev = root.querySelector('[data-fm-prev]');
          const next = root.querySelector('[data-fm-next]');
          const update = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
          const move = direction => { track.scrollBy({left: direction * (track.clientWidth + 28), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); };
          prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
          track.addEventListener('scroll', update, {passive: true}); new ResizeObserver(update).observe(track); update();
        });
      }).catch(() => sections.forEach(root => { delete root.dataset.initialised; }));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
    document.addEventListener('shopify:section:load', event => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitmarket-flash-position"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fitmarket-flash-slot')) {
    customElements.define('fitmarket-flash-slot', class extends HTMLElement {
      connectedCallback() {
        this.moveBar = () => {
          const bar = document.getElementById('pe-announcement-bar');
          if (bar && bar.parentElement !== this) this.append(bar);
        };
        this.observer = new MutationObserver(this.moveBar);
        this.observer.observe(document.body, { childList: true });
        this.moveBar();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        const bar = this.querySelector('#pe-announcement-bar');
        if (bar) document.body.prepend(bar);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitmarket-weekly-link"] && !Shopify.designMode) return;
  try {
    
  function fitmarketCountdownDeadline(date, time) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time)) return NaN;
    const [year, month, day] = date.split('-').map(Number);
    const [hour, minute] = time.split(':').map(Number);
    if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;
    const desired = Date.UTC(year, month - 1, day, hour, minute);
    const format = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    const partsAt = (value) => Object.fromEntries(format.formatToParts(value).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    let target = desired;
    for (let i = 0; i < 3; i++) {
      const parts = partsAt(target);
      const offset = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - target;
      target = desired - offset;
    }
    const actual = partsAt(target);
    if (actual.year !== year || actual.month !== month || actual.day !== day || actual.hour !== hour || actual.minute !== minute) return NaN;
    return target;
  }

  if (!customElements.get('fitmarket-offer-countdown')) {
    customElements.define('fitmarket-offer-countdown', class extends HTMLElement {
      connectedCallback() {
        const deadline = fitmarketCountdownDeadline(this.dataset.endDate || '', this.dataset.endTime || '');
        if (!Number.isFinite(deadline)) return;
        const hours = this.querySelector('[data-hours]');
        const minutes = this.querySelector('[data-minutes]');
        const seconds = this.querySelector('[data-seconds]');
        const firstUnit = this.querySelector('[data-first-unit]');
        const secondUnit = this.querySelector('[data-second-unit]');
        const thirdUnit = this.querySelector('[data-third-unit]');
        const clock = this.querySelector('[data-clock]');
        const expired = this.querySelector('[data-expired]');
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          this.hidden = false;
          clock.hidden = remaining === 0;
          expired.hidden = remaining > 0;
          const showDays = remaining > 86400;
          const values = showDays
            ? [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60]
            : [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
          const labels = showDays
            ? [this.dataset.daysLabel, this.dataset.hoursLabel, this.dataset.minutesLabel]
            : [this.dataset.hoursLabel, this.dataset.minutesLabel, this.dataset.secondsLabel];
          [hours, minutes, seconds].forEach((element, index) => { element.textContent = String(values[index]).padStart(2, '0'); });
          [firstUnit, secondUnit, thirdUnit].forEach((element, index) => { element.textContent = labels[index]; });
          if (remaining === 0) clearInterval(this.interval);
          return remaining;
        };
        if (update() > 0) this.interval = setInterval(update, 1000);
      }

      disconnectedCallback() { clearInterval(this.interval); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
